import { ClientView } from "@common/types/views/clientViews";
import { NamedView } from "@common/types/views/views";
import { useMemo } from "react";
import { useDefaultClientView } from "./DefaultClientView";

export function useBuiltInClientViews(): Array<NamedView<ClientView>> {
    const defaultClientView = useDefaultClientView();
    return useMemo(() => [defaultClientView], [defaultClientView]);
}
